export default {
  label: {
    placeholder: {
      dashboardSelect: 'Seleccione um dashboard',
    },
    title: {
      welcomeMessage: '¡Hola!',
      infoMessage: '¡Vamos a conocernos un poco más para personalizar tu experiencia!',
      firstStepMessage: 'Para empezar, cuéntanos un poco sobre ti.',
      dashboardSelectionMessage: 'Aquí encuentras tus dashboards.',
      noTitleDasboard: 'Dashboard sin título',
      requiredMessage: '* Los campos a continuación son obligatorios.',
      department: 'Departamento',
      job: 'Cargo',
      selectDashboard: 'Dashboards',
      newDepartment: 'Departamento nuevo',
      newJob: 'Cargo nuevo',
      others: 'Otros',
      finishMessage: '¡Eso es todo! Ahora tienes todo para hacer historia.',
      haveFunMessage: 'Y no olvides divertirte también ;)',
      useCaseMessage: '¿Qué tipo de uso haces de los productos de Stilingue?',
      mustChooseUseCaseMessage: 'Necesitas elegir, al menos, un caso de uso para continuar con el onboarding.',
      notFoundUseCaseMessage: 'Caso no hayas encontrado arriba.',
      writeHereMessage: 'Escribe aquí',
      dashboardModelsMessage: '¡Genial! Estos son los modelos de dashboards para ti.',
      emptyDashboardMessage: 'También puedes comenzar con un dashboard en blanco, si lo prefieres.',
      indicatedForMessage: 'Indicado para',
      chooseDashboardNameMessage: '¿Cómo te gustaría llamar a tu dashboard?',
      chooseDashboardNameLaterMessage: 'Puedes hacerlo después, si lo prefieres.',
      exploreMessage: 'Explorar',
      closeMessage: 'Cerrar Visualización',
    },
    button: {
      startFormButton: 'Vamos allá',
      nextButton: 'Próximo',
      previousButton: 'Anterior',
      lastButtonLabel: 'Hacer historia con el @:systemName',
    },
  },
  identifier: {
    step: {
      userAndCompany: 'Usuario e empresa',
      stiUseCases: 'Casos de uso STI',
      dashboardsTemplates: 'Modelos de dashboards',
      dashboardName: 'Nombre do dashboard',
      dashboardSelection: 'Escolha de dashboard',
    },
  },
};
